import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { LoginPage } from '../../user/login';
import { Storage } from '@ionic/storage';

import { AuthService } from '../../../providers/auth-service';
import { SearchParcel } from '../../qdb/search-parcel/index';

@Component({
  selector: 'custom-header',
  templateUrl: 'custom-header.html'
})
export class CustomHeaderComponent {
  header_data: any;

  constructor(private auth: AuthService, public navCtrl: NavController, private storage: Storage, public navParams: NavParams, ) {
  }
  @Input()
  set header(header_data: any) {
    this.header_data = header_data;
  }
  get header() {
    return this.header_data;
  }

  public logout() {
    this.storage.set("user_id", "0");
    window.localStorage.removeItem('user');
    this.navCtrl.setRoot(LoginPage);
  }

  public search() {
    this.navCtrl.push(SearchParcel);
  }

  public refreshPage() {
    this.header_data.parentReloadData();
  }

}


// WEBPACK FOOTER //
// ./src/pages/common/header/custom-header-component.ts